/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { Grid, SectionGrid } from "../../components/Layout"
import Img from "gatsby-image"
import { Fragment } from "react"
import { getFluidFromAsset } from "../../utils/gatsbyImageHelpers"
import { BlockText } from "../../components/BlockText"

function Manual({ manual = [] }) {
  return (
    <Grid
      columns={[
        "1fr",
        "1fr",
        `repeat(${manual.length + 1},1fr)`,
        `repeat(${manual.length + 1},1fr)`,
      ]}
      rows={`repeat(${manual.length},1fr)`}
      sx={{ marginTop: "35px" }}
    >
      {manual &&
        manual.length > 0 &&
        manual.map((step, index) => {
          return (
            <Grid
              key={index}
              columns={["1fr 1fr", "1fr 2fr", "1fr 1fr"]}
              sx={{
                gridColumn: [
                  "1 / 2",
                  "1 / 2",
                  `${index + 1} / ${index + manual.length}`,
                  `${index + 1} / ${index + manual.length}`,
                ],
                gridRow: `${index + 1}`,
              }}
            >
              {index === 0 ? (
                <Img
                  fluid={getFluidFromAsset(step.icon, 200)}
                  sx={{ height: "62px", width: ["43px", "37px"] }}
                />
              ) : (
                <Img fluid={getFluidFromAsset(step.icon, 200)} sx={{ width: "64px" }} />
              )}
              <div
                sx={{
                  variant: "text.h6",
                  textTransform: "none",
                  color: "almostBlack",
                  my: "auto",
                }}
              >
                {step.text}
              </div>
            </Grid>
          )
        })}
    </Grid>
  )
}

function Anwendung({ title, mainText, manual, image }) {
  return (
    <SectionGrid sx={{ my: "25px" }}>
      <SectionGrid.narrow sx={{ width: ["90%", "90%", "unset"], mx: "auto" }}>
        <h3
          sx={{
            variant: "text.h2",
            letterSpacing: ["0.4px", "0.21px", "0.34px", "0.56px"],
            color: "almostBlack",
          }}
        >
          {title}
        </h3>
        <Grid columns={["1fr", "1fr", "1fr 1fr", "1fr 1fr"]} gap="20px">
          {image ? (
            <Fragment>
              <section sx={{ gridColumn: "1 / 2" }}>
                <BlockText
                  blocks={mainText}
                  lang="de"
                  style={{ hyphens: "auto", "-moz-hyohens": "auto" }}
                />
                {manual && manual.length > 0 && <Manual manual={manual} />}
              </section>
              <div
                sx={{
                  gridColumn: ["1 / 2", "1 / 2", "2 / 3", "2 / 3"],
                  width: "100%",
                  maxHeight: ["300px", "400px", "500px", "650px"],
                  overflow: "hidden",
                }}
              >
                <Img
                  fluid={getFluidFromAsset(image, 500)}
                  sx={{ width: "100%", maxHeight: ["300px", "300px", "500px", "650px"] }}
                />
              </div>
            </Fragment>
          ) : (
            <section sx={{ gridColumn: ["1 / 2", "1 / 2", "1 / 3", "1 / 3"] }}>
              <BlockText blocks={mainText} />
              <Manual manual={manual} />
            </section>
          )}
        </Grid>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { Anwendung }
